import React from 'react';

import { TextButton } from 'src/components/atoms/TextButton';
import * as styles from './styles';

interface Props {
  type: string;
  elementId: string;
  isExpanded: boolean;
  toggleExpanded: VoidFunction;
}

export const ExpandableContentToggleButton = ({
  isExpanded,
  type,
  toggleExpanded,
  elementId,
}: Props) => (
  <TextButton
    css={styles.btnToggleExpanded}
    onClick={(evt) => {
      evt.stopPropagation();
      toggleExpanded();
    }}
    aria-expanded={isExpanded}
    aria-controls={elementId}
  >
    Show {isExpanded ? 'less' : 'all'} {type}
  </TextButton>
);
